import type { IconNames } from '@repo/foundations';
import { EntityType } from '../enums/entityType';

export const DEFAULT_ICONS: Partial<
	Record<EntityType, { iconName: IconNames; iconColor: string }>
> = {
	[EntityType.metric]: { iconName: 'chartHistogram', iconColor: '#4a4a4a' },
	[EntityType.collection]: { iconName: 'folder', iconColor: '#4a4a4a' },
	[EntityType.document]: { iconName: 'file', iconColor: '#4a4a4a' },
	[EntityType.question_reply]: {
		iconName: 'messageCircleQuestion',
		iconColor: '#4a4a4a',
	},
	[EntityType.question]: {
		iconName: 'messageCircleQuestion',
		iconColor: '#4a4a4a',
	},
	[EntityType.dictionary_term]: { iconName: 'book', iconColor: '#4a4a4a' },
	[EntityType.glossary]: { iconName: 'book', iconColor: '#4a4a4a' },
	[EntityType.template]: { iconName: 'template', iconColor: '#4a4a4a' },
	[EntityType.policy]: { iconName: 'fileCheck', iconColor: '#4a4a4a' },
	[EntityType.bi_metric]: { iconName: 'chartHistogram', iconColor: '#4a4a4a' },
	[EntityType.bi_dashboard]: {
		iconName: 'customDashboard',
		iconColor: '#4a4a4a',
	},
};

export const DEFAULT_TEMPLATE_ICONS: Partial<Record<EntityType, IconNames>> = {
	[EntityType.collection]: 'folders',
	[EntityType.column]: 'columns2',
	[EntityType.dashboard]: 'customDashboard',
	[EntityType.document]: 'file',
	[EntityType.glossary]: 'book',
	[EntityType.job]: 'database',
	[EntityType.question]: 'messageCircleQuestion',
	[EntityType.table]: 'table',
};
